import { MapPin, Navigation } from "lucide-react";

type Props = {
  address: string;
  /** Query for the Maps deep link — `hauseingang` with a `gebaeude` fallback. Omit to hide the button. */
  mapsQuery?: string | null;
};

/**
 * Adresse card: pin + the address as the value, "Route" as a real ≥44px button — replaces the
 * 11px `MapsLink` pill that used to sit on the label row, well under the touch-target minimum.
 */
export const AppointmentAddressCard = ({ address, mapsQuery }: Props) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-4">
    <p className="text-xs font-medium uppercase tracking-wide text-slate-500">Adresse</p>
    <div className="mt-1 flex items-center justify-between gap-3">
      <span className="flex min-w-0 items-center gap-2 text-base text-slate-900">
        <MapPin size={18} className="shrink-0 text-primary" aria-hidden="true" />
        <span className="truncate">{address || "—"}</span>
      </span>

      {mapsQuery && (
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(mapsQuery)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex h-11 shrink-0 items-center gap-1.5 rounded-xl border border-primary px-3 text-sm font-medium text-primary"
        >
          <Navigation size={16} aria-hidden="true" />
          Route
        </a>
      )}
    </div>
  </div>
);
